// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__204ZK","toggleWrap":"styles_toggleWrap__3Nz8d","content":"styles_content__37tCy","selectAreaCode":"styles_selectAreaCode__3J1h5"};